import { Link, useLocation } from "react-router-dom";
import { FaHome } from "react-icons/fa";

const Breadcrumb = ({ pageDetail }) => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter(Boolean);

    return (
        <>
            <nav className="py-3 common-container lowercase capitalize">
                <ol className="flex flex-wrap items-center text-sm text-gray-600 lowercase capitalize">

                    <li className="flex items-center">
                        <Link to="/" className="flex items-center gap-1 hover:text-primary">
                            <FaHome className="text-base" />
                        </Link>
                    </li>

                    {pageDetail ? (
                        <>
                            <li className="mx-2 text-gray-400">/</li>

                            <Link
                                to="/pages"
                                className="font-medium text-gray-700 hover:text-primary">
                                Pages
                            </Link>

                            <li className="mx-2 text-gray-400">/</li>

                            <span className="font-medium text-gray-700 ">
                                {pageDetail?.category?.toLowerCase()}
                            </span>

                            <li className="mx-2 text-gray-400">/</li>

                            <span className="font-semibold text-gray-900 ">
                                {pageDetail?.title?.toLowerCase()}
                            </span>
                        </>
                    ) : (
                        pathnames.map((value, index) => {
                            const to = "/" + pathnames.slice(0, index + 1).join("/");
                            const isLast = index === pathnames.length - 1;

                            return (
                                <li key={to} className="flex items-center">
                                    <span className="mx-2 text-gray-400">/</span>

                                    {isLast ? (
                                        <span className="font-semibold text-gray-900 ">
                                            {value.replace(/-/g, " ")}
                                        </span>
                                    ) : (
                                        <Link to={to} className="hover:text-primary ">
                                            {value.replace(/-/g, " ")}
                                        </Link>
                                    )}
                                </li>
                            );
                        })
                    )}
                </ol>
            </nav>
        </>
    );
};

export default Breadcrumb;
